import axios from 'axios';
import toast from 'react-hot-toast';

const api = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('qfl_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

let offlineToastId = null;

api.interceptors.response.use(
  (response) => {
    // Serveur de nouveau disponible — retirer le toast offline si présent
    if (offlineToastId) { toast.dismiss(offlineToastId); offlineToastId = null; }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('qfl_token');
      localStorage.removeItem('qfl_user');
      if (window.location.pathname !== '/login') window.location.href = '/login';
      return Promise.reject(error);
    }

    // Serveur inaccessible (réseau coupé ou backend offline)
    if (!error.response && !offlineToastId) {
      offlineToastId = toast.error('Serveur inaccessible. Vérifiez votre connexion.', {
        duration: Infinity,
        id: 'offline-error',
      });
    }

    return Promise.reject(error);
  }
);

export default api;
